import Seo from "@/components/Seo";
import PageLayout from "@/components/PageLayout";
import PageHero from "@/components/PageHero";
import QuoteForm from "@/components/QuoteForm";

const GetQuote = () => (
  <PageLayout>
    <Seo
      title="Get a Free Property Services Quote – Oz Property Services"
      description="Send us a few details and we'll get back to you with pricing, availability and next steps. Fast response. Residential and commercial."
      path="/get-quote"
    />
    <PageHero
      title="Get Your Property Services Quote in 60 Seconds"
      subtitle="Send us a few details and we'll get back to you with pricing, availability and next steps. Fast response • Clear pricing • Residential & commercial."
    />
    <QuoteForm showHeading={false} />
  </PageLayout>
);

export default GetQuote;
